const UINT32_BYTES = 4;

export function uint32ToLittleEndianBytes(value: number): Uint8Array {
  const bytes = new Uint8Array(UINT32_BYTES);
  new DataView(bytes.buffer).setUint32(0, value, true);
  return bytes;
}
